import Main2 from "../../pages/client/AllEquipments/PressureVessel";
import ManageStaff from "../../pages/admin/ManageStaff";

import MyTasks from "../../pages/staff/MyTasks2";

//---------project------------
import TankMain from "../../pages/client/AllEquipments/Tank/Main";
import MainProjects from "../../pages/client/Project/allProjectsPage";
import ProjectForm from "../../pages/client/Project/ProjectForm";
import EquipForm from "../../pages/client/Project/ProjectForm/EquipsForm";
import { AuthProtected } from "../AuthProtectedOutlet";
import { AdminProtected } from "../AdminProtectedOutlet";
// import AllTimesheets from "../../pages/admin/AllTimesheets";
import paths from "../../api/paths.api";
import ClientVendorsPage from "../../pages/admin/Panel/ClientVendorsPage";
import AdminPanel from "../../pages/admin/Panel";
import PlantsTable from "../../pages/client/Project/plant";
import EstimationTab from "../../pages/client/AllEquipments/Tank/Tank_Estimation/PlantEstimation";
import Estimation from "../../pages/client/AllEquipments/Tank/Tank_Estimation/";
import DCS from "../../pages/client/AllEquipments/CommonFeatures/DCSTab";
import { DCSProvider } from "../../pages/client/AllEquipments/CommonFeatures/DCSTab/Table/DCSContext";
import PCS from "../../pages/client/AllEquipments/CommonFeatures/PCSTab";
import { PCSProvider } from "../../pages/client/AllEquipments/CommonFeatures/PCSTab/PCSContext";
import { MCSContextProvider } from "../../pages/client/AllEquipments/CommonFeatures/MCS3/MCS.context";
import MCSPage from "../../pages/client/AllEquipments/CommonFeatures/MCS3";

import PMSTab2 from "../../pages/client/AllEquipments/CommonFeatures/PMSTab2";
import PlantTaskPage from "../../pages/client/Project/plant/PlantTaskPage";
import MISTab from "../../pages/client/AllEquipments/CommonFeatures/MISTab";
export const adminProtectedRoutes = [
  {
    path: "/main_pv/:name/:rev",
    element: <Main2 />,
  },
  {
    path: paths.plantEstimation,
    element: <Estimation plant={true} />,
  },
  {
    path: paths.plantPCS,
    element: (
      <PCSProvider plant={true}>
        <PCS plant={true} />
      </PCSProvider>
    ),
  },
  {
    path: paths.plantDCS,
    element: (
      <DCSProvider plant={true}>
        <DCS plant={true} />
      </DCSProvider>
    ),
  },
  // {
  //   path: paths.plantMCS,
  //   element: (
  //     // <MCSContextProvider>
  //     <MCSPage plant />
  //     // </MCSContextProvider>
  //   ),
  // },
  {
    path: paths.plantPMS,
    element: <PMSTab2 plant={true} />,
  },
  {
    path: paths.plantTask,
    element: <PlantTaskPage />,
  },
  {
    path: paths.plantMIS,
    element: <MISTab />,
  },
  // {
  //   path: "/register",
  //   element: <StaffRegister />,
  // },
  // {
  //   path: "/allstaff",
  //   element: <ManageStaff />,
  // },
  {
    path: paths.adminPanel + "/:subPanel",
    element: <AdminPanel />,
  },
  {
    path: "/new-project",
    element: <ProjectForm />,
  },
  {
    path: "/project-equipments",
    element: <EquipForm />,
  },
  {
    path: paths.clientVendors,
    element: <ClientVendorsPage />,
  },
  {
    path: "",
    element: <AuthProtected />,
    children: [
      {
        path: "/mytasks",
        element: <MyTasks />,
      },
      {
        path: "",
        element: <AdminProtected />,
        children: [
          // {
          //   path: "/main_pv",
          //   element: <Main2 />,
          // },
          // {
          //   path: "/alltimesheets",
          //   element: <AllTimesheets />,
          // },
        ],
      },
    ],
  },
];
